import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { UtilService } from '../utils';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit {

  @Output()
  eventFilesUpload = new EventEmitter<object>();

  @Input()
  filesToUpload: Array<File> = new Array<File>();

  @Input()
  public isVisualization: boolean;

  constructor(
    private utils: UtilService
    ) { }

  ngOnInit() {
  }

  handleFileInput(event) {
    this.utils.validateFileToUpload(event,  this.filesToUpload, this.eventFilesUpload);
  }

}
